module.exports = __webpack_public_path__ + "static/img/diyCardTitle.feb878b4.png";